import { useQuery } from "@tanstack/react-query"

import { getSourceControl } from "@/api/filth-source-control-api"
import { getFilthSources } from "@/api/filth-sources-api"

import { hasActiveFilthJobs } from "../components/filth-sources-utils"
import { collectFilthSourcePages } from "../components/library-editor/library-filth-sources-utils"

export function useFilthSources(backendId: string, enabled: boolean, cursor?: string) {
  return useQuery({
    queryKey: ["admin", "filthBackends", backendId, "sources", cursor ?? ""],
    queryFn: () => (cursor ? getFilthSources(backendId, cursor) : getFilthSources(backendId)),
    enabled,
    retry: false,
    refetchInterval: (query) => (enabled && hasActiveFilthJobs(query.state.data) ? 15_000 : false),
  })
}

/** Every page of `/sources` (bounded), for pickers that must reach any source. */
export function useAllFilthSources(backendId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["admin", "filthBackends", backendId, "sourcesAllPages"],
    queryFn: () => collectFilthSourcePages((cursor) => getFilthSources(backendId, cursor)),
    enabled,
    retry: false,
  })
}

export function useFilthSourceControl(backendId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["admin", "filthBackends", backendId, "control"],
    queryFn: () => getSourceControl(backendId),
    enabled,
    retry: false,
  })
}
